import { IResortStrengths } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { NextLink } from 'components/blocks/NextLink';
import { Routes } from 'routes';
import styles from './styles.module.scss';

export const Category = ({
  resortStrengths,
}: {
  resortStrengths: IResortStrengths,
}) => {
  const { t } = useOTSTranslation('common');
  const categories: { [key: string]: string } = {
    overall: t('resort.overview.overallRegion'),
    allMtnTerrain: t('resort.overview.allMtnTerrainIRegion'),
    familyFriendly: t('resort.overview.familyFriendlyRegion'),
    terrainPark: t('resort.overview.terrainParkRegion'),
    beginner: t('resort.overview.beginnerRegion'),
    apresSki: t('resort.overview.apresSkiRegion'),
    smallSkiArea: t('resort.overview.smallSkiAreaRegion'),
    intermediate: t('resort.overview.intermediateRegion'),
    expert: t('resort.overview.expertRegion'),
  };

  return (
    <div className={styles.category}>
      <span className={styles.position}>
        {t('resort.overview.positionPrefix', { value: resortStrengths.position })}
      </span>
      {` ${categories[resortStrengths.category]} `}
      <NextLink className={styles.link} href={Routes.regionSnowReport(resortStrengths.region)}>
        {resortStrengths.region.title}
      </NextLink>
    </div>
  );
};
